import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { formatMedicineActiveIngredients } from '~libs.shared.medicine';

import { StyledMedicineActiveIngredients } from './MedicineActiveIngredients.styled';

type MedicineActiveIngredientsProps = {
   readonly activeIngredients: MedicineSimple['activeIngredients'];
   readonly valid?: MedicineSimple['valid'];
};

export const MedicineActiveIngredients = (props: MedicineActiveIngredientsProps): JSX.Element | null => {
   const valid = props.valid !== false;

   return (
      <StyledMedicineActiveIngredients $valid={valid}>
         {formatMedicineActiveIngredients(props.activeIngredients)}
      </StyledMedicineActiveIngredients>
   );
};
